import React, { useState } from 'react';
import styles from './token.module.scss';
import { API_BASE_URL } from '../../api';

const TokenSearch = ({ onTokenDataFound }) => {
  const [token, setToken] = useState('');
  const [searchResult, setSearchResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSearch = async () => {
    if (!token.trim()) {
      setError('Please enter a token');
      return;
    }

    setLoading(true);
    setError('');
    setSearchResult(null);

    try {
      const response = await fetch(`${API_BASE_URL}/token/search/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token: token.trim().toUpperCase() }),
      });

      const data = await response.json();

      if (data.status === 'success') {
        setSearchResult(data.data);
      } else {
        setError(data.message || 'Token not found');
      }
    } catch (err) {
      setError('Error searching for token. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleViewData = (data) => {
    if (onTokenDataFound) {
      onTokenDataFound(data, 'view');
    }
  };

  const handleEditData = (data) => {
    if (onTokenDataFound) {
      onTokenDataFound(data, 'edit');
    }
  };

  return (
    <div className={styles.tokenSearchContainer}>
      <div className={styles.searchHeader}>
        <h2>🔍 टोकनबाट डाटा खोज्नुहोस्</h2>
        <p>आफ्नो डाटा हेर्न र सम्पादन गर्न टोकन प्रविष्ट गर्नुहोस्</p>
      </div>

      <div className={styles.searchForm}>
        <div className={styles.inputGroup}>
          <label htmlFor="token">टोकन:</label>
          <input
            type="text"
            id="token"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="उदाहरण: AB123456"
            maxLength={8}
            className={styles.tokenInput}
          />
          <small>टोकन फरमेट: 2 अक्षर + 6 अंक (जस्तै: AB123456)</small>
        </div>
        
        <button
          onClick={handleSearch}
          disabled={loading || !token.trim()}
          className={styles.searchButton}
        >
          {loading ? 'खोज्दै...' : '🔍 खोज्नुहोस्'}
        </button>
      </div>

      {error && (
        <div className={styles.errorMessage}>
          ❌ {error}
        </div>
      )}

      {searchResult && (
        <div className={styles.searchResult}>
          <div className={styles.resultHeader}>
            <h3>✅ डाटा फेला पर्यो!</h3>
            <div className={styles.accessInfo}>
              <span className={`${styles.accessBadge} ${styles[searchResult.access_type]}`}>
                {searchResult.access_type === 'view' ? '👁️ हेर्ने मात्र' :
                 searchResult.access_type === 'edit' ? '✏️ सम्पादन गर्न सकिन्छ' :
                 '🔧 प्रशासक पहुँच'}
              </span>
              {searchResult.expires_at && (
                <span className={styles.expiryInfo}>
                  ⏰ म्याद: {new Date(searchResult.expires_at).toLocaleDateString('ne-NP')}
                </span>
              )}
            </div>
          </div>

          <div className={styles.dataPreview}>
            <h4>संस्था जानकारी:</h4>
            <div className={styles.infoGrid}>
              <div className={styles.infoItem}>
                <strong>संस्था:</strong> {searchResult.capital_expenditure.institution_name}
              </div>
              <div className={styles.infoItem}>
                <strong>आर्थिक वर्ष:</strong> {searchResult.capital_expenditure.fiscal_year_display}
              </div>
              {searchResult.opened_current_year && (
                <div className={styles.infoItem}>
                  <strong>चालु वर्ष:</strong> फारम {searchResult.working_fiscal_year_display || '२०८३/०८४'} मा खोलिन्छ। पुरानो डाटा सुरक्षित छ। फारमको माथिबाट आर्थिक वर्ष बदल्न सकिन्छ।
                </div>
              )}
              <div className={styles.infoItem}>
                <strong>स्थिति:</strong> {searchResult.capital_expenditure.status}
              </div>
              <div className={styles.infoItem}>
                <strong>सिर्जना मिति:</strong> {new Date(searchResult.capital_expenditure.created_at).toLocaleDateString('ne-NP')}
              </div>
            </div>
          </div>

          <div className={styles.actionButtons}>
            {searchResult.can_view && (
              <button 
                className={`${styles.actionButton} ${styles.viewButton}`}
                onClick={() => handleViewData(searchResult)}
              >
                📊 पूर्ण डाटा हेर्नुहोस्
              </button>
            )}
            {searchResult.can_edit && (
              <button 
                className={`${styles.actionButton} ${styles.editButton}`}
                onClick={() => handleEditData(searchResult)}
              >
                ✏️ डाटा सम्पादन गर्नुहोस्
              </button>
            )}
          </div>
        </div>
      )}

      <div className={styles.helpSection}>
        <h4>💡 सहायता:</h4>
        <ul>
          <li>टोकन आपको डाटा सुरक्षित राख्नको लागि प्रयोग गरिन्छ</li>
          <li>टोकन फरमेट: 2 अंग्रेजी अक्षर + 6 अंक (जस्तै: AB123456)</li>
          <li>यदि टोकन काम गर्दैन भने आफ्नो प्रशासकलाई सम्पर्क गर्नुहोस्</li>
          <li>टोकन सुरक्षित राख्नुहोस् र अरूलाई नदिनुहोस्</li>
        </ul>
      </div>
    </div>
  );
};

export default TokenSearch;
